import { CommentService } from '@src/services/CommentService';
import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

/**
 * DI seam for `CommentService`. Holds a resolver to the lazily-constructed
 * `CommentRepository` (built by `DatoClientStore` once auth is wired), mirroring
 * `useZoomService`.
 */
export function useCommentService(): CommentService {
  const datoClientStore = useDatoClient();
  return useMemo(
    () => new CommentService(() => datoClientStore.commentRepository),
    [datoClientStore],
  );
}
